// 保存データの圧縮・展開（2026-10-21〜）。形は zlib（前の画面のエンジンの charat.common.strToZipStr・zipStrToStr、各 restore.php、
// クラシック版と同じ）。ブラウザの CompressionStream・DecompressionStream を使い、Zlib.js（inflate・deflate、18KB）はふだん読まない:
//   - 展開できないブラウザ（Safari 16.3 まで など）だけ、そのときに /common/js/inflate.min.js を読む
//   - 圧縮できないブラウザと、すぐに書かないといけないとき（ページを離れるときのオートセーブ）は「圧縮しない zlib」（stored ブロック）。
//     どの展開（Zlib.js・ブラウザ・PHP）でも読める。中身が同じなら、圧縮したものより大きいだけ
// 文字列は1文字1バイト（charCodeAt & 255）で扱う（保存データは ASCII。前と同じ）

const toBytes = (s: string) => {
  const b = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 255;
  return b;
};
const toStr = (b: Uint8Array) => {
  let s = '';
  for (let p = 0; p < b.length; p += 8192) s += String.fromCharCode.apply(null, b.subarray(p, p + 8192) as unknown as number[]);
  return s;
};
const through = (bytes: Uint8Array<ArrayBuffer>, stream: CompressionStream | DecompressionStream) => new Response(new Blob([bytes]).stream().pipeThrough(stream)).arrayBuffer().then((buf) => new Uint8Array(buf));

// 圧縮しない zlib（すぐに返す）。ヘッダー 78 01・65535 バイトずつの stored ブロック・Adler-32
export function zipNow(text: string): string {
  const d = toBytes(text), blocks = Math.max(1, Math.ceil(d.length / 65535));
  const out = new Uint8Array(2 + blocks * 5 + d.length + 4);
  let o = 0;
  out[o++] = 0x78;
  out[o++] = 0x01;
  for (let i = 0; i < blocks; i++) {
    const at = i * 65535, len = Math.min(65535, d.length - at);
    out[o++] = i === blocks - 1 ? 1 : 0;
    out[o++] = len & 255;
    out[o++] = len >> 8;
    out[o++] = ~len & 255;
    out[o++] = (~len >> 8) & 255;
    out.set(d.subarray(at, at + len), o);
    o += len;
  }
  let s1 = 1, s2 = 0;
  for (let i = 0; i < d.length; i++) {
    s1 = (s1 + d[i]) % 65521;
    s2 = (s2 + s1) % 65521;
  }
  out[o++] = s2 >> 8;
  out[o++] = s2 & 255;
  out[o++] = s1 >> 8;
  out[o++] = s1 & 255;
  return toStr(out);
}

// 圧縮（Promise）
export function zip(text: string): Promise<string> {
  if (typeof CompressionStream !== 'function') return Promise.resolve(zipNow(text));
  return through(toBytes(text), new CompressionStream('deflate')).then(toStr);
}

// Zlib.js の展開（古いブラウザだけ、使うときに読む）
let inflateLoading: Promise<void> | null = null;
export function loadInflate() {
  if (window.Zlib && window.Zlib.Inflate) return Promise.resolve();
  if (!inflateLoading) {
    inflateLoading = new Promise<void>((resolve, reject) => {
      const s = document.createElement('script');
      s.src = '/common/js/inflate.min.js';
      s.onload = () => resolve();
      s.onerror = () => { inflateLoading = null; reject(new Error('inflate.min.js')); };
      document.head.appendChild(s);
    });
  }
  return inflateLoading;
}

// 展開（Promise。壊れたデータは reject）
export function unzip(z: string): Promise<string> {
  if (typeof DecompressionStream === 'function') return through(toBytes(z), new DecompressionStream('deflate')).then(toStr);
  return loadInflate().then(() => toStr(new window.Zlib!.Inflate(toBytes(z)).decompress()));
}
